import { defaultHttpClient } from '../../httpClient';
import type { PatchMyInfoRequest } from './types';

export const patchMyInfo = async (data: PatchMyInfoRequest) => {
  return defaultHttpClient
    .request<void>({
      method: 'PUT',
      url: '/api/v2/members/me/',
      data,
    })
    .then(result => result.data);
};
